(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["prestan-landing"]) return;
  try {
    
document.querySelectorAll('.prestan-lp .faq-question').forEach(function (b) {
  b.addEventListener('click', function () {
    b.parentElement.classList.toggle('open');
  });
});
var firstFaq = document.querySelector('.prestan-lp .faq-item');
if (firstFaq) { firstFaq.classList.add('open'); }

window.dataLayer = window.dataLayer || [];
document.querySelectorAll('.prestan-lp .product-card, .prestan-lp .diversity-card, .prestan-lp .reorder-item').forEach(function (el) {
  el.addEventListener('click', function () {
    var name = el.getAttribute('data-product-name');
    if (!name) {
      var node = el.querySelector('.product-title, h4, .reorder-item-name');
      name = node ? node.textContent : 'unknown';
    }
    window.dataLayer.push({ event: 'product_click', product_name: name.trim(), page_type: 'prestan_landing' });
  });
});
document.querySelectorAll('.prestan-lp a[href^="tel:"]').forEach(function (el) {
  el.addEventListener('click', function () {
    window.dataLayer.push({ event: 'bulk_phone_click', page_type: 'prestan_landing' });
  });
});
document.querySelectorAll('.prestan-lp a[href^="mailto:"]').forEach(function (el) {
  el.addEventListener('click', function () {
    window.dataLayer.push({ event: 'bulk_email_click', page_type: 'prestan_landing' });
  });
});
var fired = {};
window.addEventListener('scroll', function () {
  var pct = (window.scrollY + window.innerHeight) / document.body.scrollHeight * 100;
  if (pct >= 50 && !fired.s50) { fired.s50 = true; window.dataLayer.push({ event: 'scroll_50', page_type: 'prestan_landing' }); }
  if (pct >= 90 && !fired.s90) { fired.s90 = true; window.dataLayer.push({ event: 'scroll_90', page_type: 'prestan_landing' }); }
}, { passive: true });

  } catch(e) { console.error(e); }
})();
})();
